var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCirarrright16(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-304)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#9c9c9c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m312 0c-2.517 0-4.768 1.1732-6.2363 3h2.9102c0.95078-0.632 2.0934-1 3.3262-1 3.3256 0 6 2.6745 6 6 0 3.3255-2.6744 6-6 6-1.2328 0-2.3754-0.368-3.3262-1h-2.9102c1.4683 1.8268 3.7193 3 6.2363 3 4.4064 0 8-3.5936 8-8 0-4.4064-3.5936-8-8-8z",
    color: "#000000",
    style: {
      InkscapeStroke: "none",
      paintOrder: "markers stroke fill"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m308 4a1 1 0 0 0-0.70703 0.29297l-3 3a1 1 0 0 0 0 1.4141l3 3a1 1 0 0 0 1.4141 0 1 1 0 0 0 0-1.4141l-1.293-1.293h7.5859a1 1 0 0 0 1-1 1 1 0 0 0-1-1h-7.5859l1.293-1.293a1 1 0 0 0 0-1.4141 1 1 0 0 0-0.70703-0.29297z",
    color: "#000000",
    strokeLinecap: "round",
    style: {
      InkscapeStroke: "none"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCirarrright16);
export default __webpack_public_path__ + "static/media/cirarr.right.16.4966cc9b5fa71bd59827d2858ea00f88.svg";
export { ForwardRef as ReactComponent };